<template>
  <div class="box">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="到期预警" name="first">
        <expire  v-if="activeName === 'first'" />
      </el-tab-pane>
      <el-tab-pane label="预警" name="second">
        <region v-if="activeName === 'second'" />
      </el-tab-pane>
      <!-- <el-tab-pane label="设备报警" name="third">
        <equipment  v-if="activeName === 'third'" />
      </el-tab-pane> -->
      <el-tab-pane label="人员报警" name="fourth">
        <personnel v-if="activeName === 'fourth'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import equipment from './tabPanel/equipment'
import expire from './tabPanel/expire'
import personnel from './tabPanel/personnel'
import region from './tabPanel/region'

export default {
  name: 'earlyWarning',
  components: {
    equipment,
    expire,
    region,
    personnel
  },
  data(){
    return {
      activeName: 'second'
    }
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    }
  }
}
</script>

<style scoped>
  .box{
    width: 100%;
    height: 100%;
    /* overflow: scroll; */
    background: white;
    padding: 10px 20px;
  }
</style>